import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDcentertainmentComponent } from './simple-icons-dcentertainment.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDcentertainmentComponent ],
    exports:      [ SimpleIconsDcentertainmentComponent ],
    bootstrap:    []
})
export class SimpleIconsDcentertainmentModule {}
